/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetUserTemporaryPinCodesPathParameters } from 'api/actions/get-user-temporary-pin-codes/get-user-temporary-pin-codes-path-parameters';
import { GetUserTemporaryPinCodesResponse } from 'api/actions/get-user-temporary-pin-codes/get-user-temporary-pin-codes-response';

type GetUserTemporaryPinCodesQueryParameters = Record<string, any>;

/**
 * The path of the GetUserTemporaryPinCodes action.
 */
export const getUserTemporaryPinCodesActionPath = new SweetPath<keyof GetUserTemporaryPinCodesPathParameters>(
  '/user/pin/temporary',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetUserTemporaryPinCodes actions.
 */
export default function createGetUserTemporaryPinCodesAction(axios: AxiosInstance) {
  return function getUserTemporaryPinCodesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetUserTemporaryPinCodesQueryParameters } = {}) {
    const path = getUserTemporaryPinCodesActionPath.original;

    return axios.get<GetUserTemporaryPinCodesResponse, GetUserTemporaryPinCodesResponse>(path, {
      params: query,
      headers,
    });
  };
}
